import { Tooltip } from "devextreme-react/tooltip";
import React from "react";

// A lock icon beside a field that cannot be edited, with a tooltip saying why.
type Props = {
    id: string;
    text: string;
};

export const TASK_FOLDER_LOCK_TEXT =
    "Locked because this task has instances. Their SharePoint folders are named from its number, so changing it would split the files across multiple folders.";

export default function LockedFieldHint({ id, text }: Props) {
    return (
        <>
            <i id={id} className="dx-icon-lock" style={{ color: "#888", cursor: "help", marginLeft: "4px" }} aria-label="Why this is locked" />
            <Tooltip
                target={`#${id}`}
                showEvent="mouseenter"
                hideEvent="mouseleave"
                hideOnOutsideClick={false}
                position="top"
            >
                <div style={{ padding: "8px 10px", fontSize: "12px", maxWidth: "320px", whiteSpace: "normal" }}>{text}</div>
            </Tooltip>
        </>
    );
}
